// Put a panel back at the top of the viewport after a save.
//
// Saving goes through the app's global spinner (a Bootstrap Modal), and while
// that modal is up the body can't scroll — a window.scrollTo issued underneath
// it is clamped to 0, which is why "restore the Y we captured" left the report
// scrolled to the very top instead of where the practitioner was editing. And
// the modal closing on top of a layout that just shrank (a tall editor became a
// shorter preview) drops the page at the top on its own. So: scroll only AFTER
// the save has resolved (spinner gone), and anchor on the panel's own element
// rather than a captured Y, since the panel is a different height by then.
//
// The sticky header (.App-sticky-top) sits over the top of the page, so offset
// by its height — same pattern as scrollComparisonTitleIntoView in the
// comparison report.
export function scrollPanelIntoView(
  target: string | HTMLElement | null,
): void {
  const scroll = () => {
    const el =
      typeof target === 'string' ? document.getElementById(target) : target;
    if (!el || typeof window.scrollTo !== 'function') return;
    const sticky = document.querySelector('.App-sticky-top') as HTMLElement | null;
    const stickyHeight = sticky ? sticky.getBoundingClientRect().height : 0;
    const top = el.getBoundingClientRect().top + window.scrollY - stickyHeight;
    window.scrollTo({ top: Math.max(top, 0) });
  };
  // Once on the next frame, then again once the spinner modal has definitely
  // unmounted and released the body scroll lock.
  requestAnimationFrame(scroll);
  window.setTimeout(scroll, 250);
}
